import { NavigationMenu } from "@base-ui/react/navigation-menu";
import { useRef, useState } from "react";
import { Input } from "../../Input";
import { IconClose, IconSearch } from "../../icons";
import { ScrollArea } from "../../ScrollArea";
import { MenuSubitem } from "../MenuSubitem";
import {
  itemsListClass,
  menuItemWrapperClass,
  menuModalStyleClass,
  modalHeaderClass,
  nothingFoundSpanClass,
  searchContainerClass,
  searchContainerOpenClass,
} from "../styles.css";
import type { MenuItemProps } from "../types";

interface MenuSearchProps {
  sideBarOpen: boolean;
  searchInput: string;
  onSearchChange: (value: string) => void;
  onActiveSearchChange: (value: string) => void;
  searchItems: MenuItemProps[];
  searchPlaceholder?: string;
  searchEmptyMessage?: string;
  onInputFocus?: () => void;
  onInputBlur?: (popupHovered: boolean) => void;
}

export const SEARCH_NAV_VALUE = "search";

export const MenuSearch = ({
  sideBarOpen,
  searchInput,
  onSearchChange,
  onActiveSearchChange,
  searchItems,
  searchPlaceholder = "Buscar",
  searchEmptyMessage = "Nenhum resultado encontrado",
  onInputFocus,
  onInputBlur,
}: MenuSearchProps) => {
  const [innerSearch, setInnerSearch] = useState("");
  const popupHoveredRef = useRef(false);

  const filtered = searchItems.filter((item) =>
    item.searchText?.toLowerCase().includes(innerSearch.toLowerCase()),
  );

  if (sideBarOpen) {
    return (
      <div
        id="menu-item/search"
        className={`${searchContainerClass} ${searchContainerOpenClass}`}
      >
        <Input
          placeholder={searchPlaceholder}
          iconLeft={<IconSearch />}
          iconRight={
            searchInput.length > 0 && (
              <IconClose onClick={() => onSearchChange("")} />
            )
          }
          value={searchInput}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={() => onActiveSearchChange(searchInput)}
        />
      </div>
    );
  }

  return (
    <NavigationMenu.Item
      value={SEARCH_NAV_VALUE}
      className={menuItemWrapperClass}
    >
      <NavigationMenu.Trigger
        nativeButton={false}
        render={<div className={searchContainerClass} id="menu-item/search" />}
      >
        <IconSearch />
      </NavigationMenu.Trigger>
      <NavigationMenu.Content
        className={menuModalStyleClass}
        onMouseEnter={() => {
          popupHoveredRef.current = true;
        }}
        onMouseLeave={() => {
          popupHoveredRef.current = false;
        }}
      >
        <span className={modalHeaderClass}>{searchPlaceholder}</span>
        <div className={itemsListClass}>
          <Input
            placeholder={searchPlaceholder}
            iconLeft={<IconSearch />}
            iconRight={
              innerSearch.length > 0 && (
                <IconClose
                  style={{ cursor: "pointer" }}
                  onClick={() => setInnerSearch("")}
                />
              )
            }
            value={innerSearch}
            onChange={(e) => setInnerSearch(e.target.value)}
            onFocus={() => onInputFocus?.()}
            onBlur={() => onInputBlur?.(popupHoveredRef.current)}
          />
          {innerSearch && (
            <ScrollArea maxHeight="calc(100vh - 120px)">
              {filtered.length > 0 ? (
                filtered.map((subitem) => (
                  <MenuSubitem key={subitem.key} subitem={subitem} />
                ))
              ) : (
                <span
                  className={nothingFoundSpanClass}
                  style={{ textAlign: "center" }}
                >
                  {searchEmptyMessage}
                </span>
              )}
            </ScrollArea>
          )}
        </div>
      </NavigationMenu.Content>
    </NavigationMenu.Item>
  );
};
